export const CITIES_KEY = 'cities';
export const PROBLEM_STATUSES_KEY = 'problems-statuses';
export const PROBLEM_TYPES_KEY = 'problem-types';
